import React, { FC } from 'react'
import { ClassValue } from 'clsx'
import cn from '../../lib/utils/cn'
import Loader from './Loader'
import AppContext from '../../context/appContext'

interface LockerLoaderProps {
	visible: boolean
	className?: ClassValue
	size?: number
}

const LockerLoader: FC<LockerLoaderProps> = ({
	visible,
	className,
	size = 50,
}) => {
	const { darkMode } = React.useContext(AppContext)
	if (!visible) return null

	return (
		<div
			className={cn(
				'absolute inset-0 bg-white/50 dark:bg-background-dark/50 z-40 flex items-center justify-center',
				darkMode && 'bg-background-dark',
				className
			)}
		>
			<Loader size={size} />
		</div>
	)
}

export default LockerLoader
